export {default as queue} from "./src/queue";



//////////////////
// WEBPACK FOOTER
// ./~/d3-queue/index.js
// module id = px6/
// module chunks = 0